import urlTemplate from 'url-template';
export const PARTNER_NAV_ITEMS = {
  APPS: 'APPS',
  DETAILS: 'DETAILS',
  TEAM: 'TEAM',
  PAYMENT_INFO: 'PAYMENT_INFO',
  PROMOTIONS: 'PROMOTIONS',
  SECURITY: 'SECURITY',
  REPORTS: 'REPORTS',
  ADMIN: 'ADMIN',
  AUDIT_LOGS: 'AUDIT_LOGS',
  SALE_REPORTS: 'SALE_REPORTS',
  EVALUATIONS_REPORTS: 'EVALUATIONS_REPORTS',
  FEEDBACK_REPORTS: 'FEEDBACK_REPORTS',
  CLOUD_CONVERSIONS_REPORTS: 'CLOUD_CONVERSIONS_REPORTS',
  CLOUD_RENEWALS_REPORTS: 'CLOUD_RENEWALS_REPORTS',
  CLOUD_CHURN_REPORTS: 'CLOUD_CHURN_REPORTS',
  TRANSACTIONS_REPORTS: 'TRANSACTIONS_REPORTS',
  LICENSES_REPORTS: 'LICENSES_REPORTS',
  FEEDBACK_DETAILS_REPORTS: 'FEEDBACK_DETAILS',
  CREATE_PROMOTION: 'CREATE_PROMOTION',
  PROMOTION_DETAILS: 'PROMOTION_DETAILS',
  CODES: 'CODES',
  PRICING: 'PRICING',
  APP_VERSIONS: 'APP_VERSIONS',
  APP_DETAILS: 'APP_DETAILS',
  APP_PRICING: 'APP_PRICING',
  APP_PRIVACY_AND_SECURITY: 'APP_PRIVACY_AND_SECURITY',
  APP_ACTIVE_INSTALLS: 'APP_ACTIVE_INSTALLS',
  APP_PRIVATE_LISTINGS: 'APP_PRIVATE_LISTINGS',
  APP_DOWNLOADS: 'APP_DOWNLOADS',
  APP_MARKETING: 'APP_MARKETING',
  APP_ADMIN: 'APP_ADMIN',
  APP_EDITIONS: 'APP_EDITIONS',
  APP_VERSION_TRANSITION: 'APP_VERSION_TRANSITION',
  APP_VERSION_DETAILS: 'APP_VERSION_DETAILS',
  APP_VERSION_HIGHLIGHTS: 'APP_VERSION_HIGHLIGHTS',
  APP_VERSION_MEDIA: 'APP_VERSION_MEDIA',
  APP_VERSION_INSTRUCTIONS: 'APP_VERSION_INSTRUCTIONS',
  APP_VERSION_COMPATIBILITY: 'APP_VERSION_COMPATIBILITY',
  APP_VERSION_LINKS: 'APP_VERSION_LINKS',
  APP_VERSION_ADMIN: 'APP_VERSION_ADMIN',
  APP_CLOUD_PRICING: 'APP_CLOUD_PRICING',
  APP_DATA_CENTER_PRICING: 'APP_DATA_CENTER_PRICING',
  APP_SERVER_PRICING: 'APP_SERVER_PRICING',
  APP_GOV_CLOUD_PRICING: 'APP_GOV_CLOUD_PRICING',
  APP_ISOLATED_CLOUD_PRICING: 'APP_ISOLATED_CLOUD_PRICING'
};
export const managePartnerBaseLink = () => urlTemplate.parse('/manage/vendors/{id}');
export const manageAppsBaseLink = () => urlTemplate.parse('/manage/apps/{id}');
export const getPartnerNavLinks = () => ({
  /* Manage Partner navigation links */
  [PARTNER_NAV_ITEMS.APPS]: urlTemplate.parse('/manage/vendors/{id}/addons'),
  [PARTNER_NAV_ITEMS.DETAILS]: urlTemplate.parse('/manage/vendors/{id}/details'),
  [PARTNER_NAV_ITEMS.TEAM]: urlTemplate.parse('/manage/vendors/{id}/contacts'),
  [PARTNER_NAV_ITEMS.PAYMENT_INFO]: urlTemplate.parse('/manage/vendors/{id}/payment'),
  [PARTNER_NAV_ITEMS.REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/{key}'),
  [PARTNER_NAV_ITEMS.PROMOTIONS]: urlTemplate.parse('/manage/vendors/{id}/promos'),
  [PARTNER_NAV_ITEMS.SECURITY]: urlTemplate.parse('/manage/vendors/{id}/security'),
  [PARTNER_NAV_ITEMS.ADMIN]: urlTemplate.parse('/manage/vendors/{id}/admin'),
  [PARTNER_NAV_ITEMS.AUDIT_LOGS]: urlTemplate.parse('/manage/vendors/{id}/auditlogs'),
  /* Reports nested navigation links */
  [PARTNER_NAV_ITEMS.SALE_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/sales?period=past90Days'),
  [PARTNER_NAV_ITEMS.EVALUATIONS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/evaluations?period=past90Days'),
  [PARTNER_NAV_ITEMS.FEEDBACK_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/feedback?period=past90Days'),
  [PARTNER_NAV_ITEMS.CLOUD_CONVERSIONS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/conversions?period=past90Days'),
  [PARTNER_NAV_ITEMS.CLOUD_RENEWALS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/renewals?period=past90Days'),
  [PARTNER_NAV_ITEMS.CLOUD_CHURN_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/churn?period=past90Days'),
  [PARTNER_NAV_ITEMS.TRANSACTIONS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/transactions'),
  [PARTNER_NAV_ITEMS.LICENSES_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/licenses'),
  [PARTNER_NAV_ITEMS.FEEDBACK_DETAILS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/feedback-details'),
  /* Promotions sub tab links */
  [PARTNER_NAV_ITEMS.CREATE_PROMOTION]: urlTemplate.parse('/manage/vendors/{id}/promos/create'),
  [PARTNER_NAV_ITEMS.PROMOTION_DETAILS]: urlTemplate.parse('/manage/vendors/{id}/promos/{key}/details'),
  [PARTNER_NAV_ITEMS.CODES]: urlTemplate.parse('/manage/vendors/{id}/promos/{key}/codes'),
  [PARTNER_NAV_ITEMS.PRICING]: urlTemplate.parse('/manage/vendors/{id}/promos/{key}/pricing'),
  /* Manage Apps navigation links */
  [PARTNER_NAV_ITEMS.APP_VERSIONS]: urlTemplate.parse('/manage/apps/{id}/versions'),
  [PARTNER_NAV_ITEMS.APP_DETAILS]: urlTemplate.parse('/manage/apps/{id}/details'),
  [PARTNER_NAV_ITEMS.APP_PRICING]: urlTemplate.parse('/manage/apps/{id}/pricing'),
  /* Pricing hosting type links */
  [PARTNER_NAV_ITEMS.APP_CLOUD_PRICING]: urlTemplate.parse('/manage/apps/{id}/pricing'),
  [PARTNER_NAV_ITEMS.APP_DATA_CENTER_PRICING]: urlTemplate.parse('/manage/apps/{id}/pricing'),
  [PARTNER_NAV_ITEMS.APP_SERVER_PRICING]: urlTemplate.parse('/manage/apps/{id}/pricing'),
  [PARTNER_NAV_ITEMS.APP_GOV_CLOUD_PRICING]: urlTemplate.parse('/manage/apps/{id}/pricing'),
  [PARTNER_NAV_ITEMS.APP_ISOLATED_CLOUD_PRICING]: urlTemplate.parse('/manage/apps/{id}/pricing'),
  [PARTNER_NAV_ITEMS.APP_PRIVACY_AND_SECURITY]: urlTemplate.parse('/manage/apps/{id}/privacy-and-security'),
  [PARTNER_NAV_ITEMS.APP_ACTIVE_INSTALLS]: urlTemplate.parse('/manage/apps/{id}/analytics'),
  [PARTNER_NAV_ITEMS.APP_PRIVATE_LISTINGS]: urlTemplate.parse('/manage/apps/{id}/private-listings'),
  [PARTNER_NAV_ITEMS.APP_DOWNLOADS]: urlTemplate.parse('/manage/apps/{id}/downloads'),
  [PARTNER_NAV_ITEMS.APP_MARKETING]: urlTemplate.parse('/manage/apps/{id}/marketing'),
  [PARTNER_NAV_ITEMS.APP_ADMIN]: urlTemplate.parse('/manage/apps/{id}/admin'),
  [PARTNER_NAV_ITEMS.APP_EDITIONS]: urlTemplate.parse('/manage/apps/{id}/editions'),
  /* Manage App version navigation links */
  [PARTNER_NAV_ITEMS.APP_VERSION_TRANSITION]: urlTemplate.parse('/manage/apps/{id}/versions/{key}/transition'),
  [PARTNER_NAV_ITEMS.APP_VERSION_DETAILS]: urlTemplate.parse('/manage/apps/{id}/versions/{key}/details'),
  [PARTNER_NAV_ITEMS.APP_VERSION_HIGHLIGHTS]: urlTemplate.parse('/manage/apps/{id}/versions/{key}/highlights'),
  [PARTNER_NAV_ITEMS.APP_VERSION_MEDIA]: urlTemplate.parse('/manage/apps/{id}/versions/{key}/media'),
  [PARTNER_NAV_ITEMS.APP_VERSION_INSTRUCTIONS]: urlTemplate.parse('/manage/apps/{id}/versions/{key}/installation'),
  [PARTNER_NAV_ITEMS.APP_VERSION_COMPATIBILITY]: urlTemplate.parse('/manage/apps/{id}/versions/{key}/compatibility'),
  [PARTNER_NAV_ITEMS.APP_VERSION_LINKS]: urlTemplate.parse('/manage/apps/{id}/versions/{key}/links'),
  [PARTNER_NAV_ITEMS.APP_VERSION_ADMIN]: urlTemplate.parse('/manage/apps/{id}/versions/{key}/admin')
});
export const appVersionPublishRoute = urlTemplate.parse('/manage/apps/{id}/versions/create');
export const appVersionDetailsRoute = urlTemplate.parse('/manage/apps/{id}/versions/{buildNumber}/details');